import styled from 'styled-components'
import { device } from 'constants/media-query'

export const StyledPlayerImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  padding-bottom: 25px;
  @media ${device.desktop} {
    align-items: center;
    padding-bottom: 0;
  }
`
export const StyledMiniTitle = styled.h2`
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 19.36px;
  text-align: start;
  margin: 0;
  width: max-content;
  text-wrap: auto;
`

export const StyledText = styled.div`
  display: flex;
  justify-content: flex-start;
  font-size: 10px;
  text-align: start;
  margin: 0;
  padding: 0;
`

export const StyledDropdownContainer = styled.div`
  display: inline-flex;
  @media ${device.desktop} {
    align-items: flex-start;
  }
`

export const StyledSelect = styled.select`
  display: inline-flex;
  height: 42px;
  padding: 11px 12px 12px 10px;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
  border-radius: 4px;
  border: 1px solid #565656;
  color: var(--Black, #000);
  text-align: right;
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  width: 165px;
`

export const StyledOption = styled.option`
  display: flex;
  width: 165px;
  height: 198px;
  padding: 16px;
  flex-direction: column;
  align-items: flex-end;
  gap: 24px;
  flex-shrink: 0;
  border-radius: 4px;
  background: white !important;
  box-shadow: 0px 1.56px 26.524px 0px rgba(0, 0, 0, 0.1);
`
